import { useCallback, useEffect } from 'react'
import type { Options } from 'react-scan'
import { scan } from 'react-scan/all-environments'
import { configureReactScan } from '#store/debugConfiguration'
import { useSharedAppDispatch, useSharedAppSelector } from '#store/sharedBaseStore'

/**
 * Configures react-scan based on the configuration of the redux stored state.
 * Update the configuration either by using the returned callback or dispatching
 * a configuration change yourself via `dispatch(configureReactScan(reconfigure));`
 * @returns
 */
export const useReactScan = () => {
  const configuration = useSharedAppSelector((x) => x.debug.reactScan)
  const dispatch = useSharedAppDispatch()
  useEffect(() => {
    // @ts-expect-error: React Scan has weird type coercion
    scan(configuration)
  })

  const reconfigureCallback = useCallback(
    (reconfigure: Options) => {
      dispatch(configureReactScan(reconfigure))
    },
    [dispatch],
  )

  return reconfigureCallback
}
